import React from 'react';

export interface NoRecordProps {
    className?: string;
}

export const NoRecord: React.FunctionComponent<NoRecordProps> = ({ children, className }) => {
    return (<div className={className}>{children}</div>);
}

export default NoRecord;